import React, { useState, useContext, useRef } from "react";
import DialogWrapperStyle from "./DialogProvider.style";

type ProviderContext = readonly [(option: DialogOption) => void, () => void];
type DialogOption = Omit<DialogParams, "open">;
const DialogContext = React.createContext<ProviderContext | null>(null);
type DialogParams = {
  children?: React.ReactNode;
  open: boolean;
  onExited?: () => void;
};

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (context !== null) {
    return context;
  }

  throw new Error("Context should be only used inside provider");
};

export interface DialogProviderProps {
  children: React.ReactNode;
}

export const DialogProvider: React.FC<DialogProviderProps> = (
  props: DialogProviderProps
) => {
  const { children } = props;
  const [dialog, setDialog] = useState<DialogParams>();

  const createDialog = (option: DialogOption) => {
    const newDialog = { ...option, open: true };
    setDialog(newDialog);
  };

  const closeDialog = () => {
    setDialog({ ...dialog, open: false });
  };

  const contextValue = useRef([createDialog, closeDialog] as const);

  return (
    <DialogContext.Provider value={contextValue.current}>
      {children}
      {dialog?.open && (
        <DialogWrapperStyle>{dialog.children}</DialogWrapperStyle>
      )}
    </DialogContext.Provider>
  );
};
